var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box",on:{"click":_vm.show_popup}},[_c('img',{staticClass:"img",attrs:{"src":_vm.$OSSBaseUrl+'bg8.png',"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }